(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("navbar", [], factory);
	else if(typeof exports === 'object')
		exports["navbar"] = factory();
	else
		root["navbar"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 